<template>
  <svg-icon type="mdi" :path="path"></svg-icon>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiCogOutline } from '@mdi/js'

export default {
  name: 'IconSettings',
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiCogOutline
    }
  }
}
</script>
